<template>
    <form id="onboarding-de" class="wrapper wrapper-tab wrapper-tab-7" role="form" method="post" @submit.prevent="" novalidate>
        <header>
            <span class="new-headline-xlg text-centered">Bitte laden Sie hier Ihren aktuell gültigen Medikamentenplan hoch</span>
            <p class="new-text-lg text-centered">Sie können auch einfach ein Foto Ihres aktuellen Medikamentenplans hochladen.</p>
        </header>

        <div class="form-input-wrapper">
            <form-input-upload-file
                name="medication_plan"
                label="Gültigen Medikamentenplan hochladen"
                :allowed-files="['.pdf', '.jpg', '.png', '.jpeg']"
                :max-files-count="2"
                :errors="errors.medication_plan"
            ></form-input-upload-file>

            <form-input-type-checkbox
                name="medication_file_check"
                :value="!hasMedicationPlan"
                label="Ich habe aktuell keinen Medikamentenplan zum Hochladen zur Verfügung"
                full-border
            />

            <v-button
                label="Weiter"
                size="lg"
                type="submit"
                @onClick="onClickButton()"
                full-width
            ></v-button>
        </div>
    </form>
</template>

<script>
    export default {
        props: {
            uuid: {
                type: String,
                required: true
            },
            data: {
                type: Object,
                required: false
            },
            type: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                errors: {},
                hasFiles: false,
                hasError: false,
                files: null,
                hasMedicationPlan: (this.data && this.data.has_medication_plan) ? (this.data.has_medication_plan === 'true') : true
            }
        },

        mounted() {
            const that = this
            const checkbox = document.getElementById('medication_file_check')

            checkbox.addEventListener('change', function() {
                if(checkbox.checked) {
                    that.errors = {
                        medication_plan: null
                    }
                    that.hasMedicationPlan = false
                    that.$forceUpdate();
                }
            })
        },

        methods: {
            onClickButton() {
                this.validate()

                if(!this.isDisabled) {
                    this.submit()
                } else {
                    Vuemit.fire('Button--sending-failed', true)
                }
            },
            validate() {
                const checkbox = document.getElementById('medication_file_check')
                const fileInput = document.querySelector("input[type=file]")
                this.files = [...fileInput.files]

                if(!checkbox.checked) {
                    if(this.files.length > 0) {
                        this.errors = {
                            medication_plan: null
                        }
                        this.isDisabled = false
                    } else {
                        this.errors.medication_plan = ["Medikamentenplan muss hochgeladen werden."]
                        this.isDisabled = true
                    }

                    this.hasMedicationPlan = true
                } else {
                    this.errors = {
                        medication_plan: null
                    }
                    this.isDisabled = false
                    this.hasMedicationPlan = false
                }

                this.$forceUpdate();
            },
            submit() {
                if(this.hasMedicationPlan) {
                    var formData = new FormData()

                    formData.append('uuid', this.uuid)
                    formData.append('answers[medication_plan][key]', 'has_medication_plan')
                    formData.append('answers[medication_plan][value]', this.hasMedicationPlan)
                    formData.append('answers[last_tab][key]', 'last_tab')
                    formData.append('answers[last_tab][value]', '7')

                    if (this.files.length > 0) {
                        for (let i = 0; i < this.files.length; i++) {
                            formData.append(`medication_plan[${i}]`, this.files[i])
                        }
                    }
                } else {
                    var formData = {
                        uuid: this.uuid,
                        answers: {
                            medication_check: {
                                key: 'has_medication_plan',
                                value: this.hasMedicationPlan ? 'true' : 'false'
                            },
                            last_tab: {
                                key: 'last_tab',
                                value: this.type === 'first' ? '8' : '6'
                            }
                        },
                        has_medication_plan: false
                    }
                }
            
                axios
                    .post('/rwe-study', formData, {
                        headers: {
                            'Accept-Language': 'de'
                        }
                    })
                    .then((e) => {
                        this.$emit('clicked', null, true)
                    })
                    .catch((e) => {
                        console.log(e.response)
                        Vuemit.fire('Button--sending-failed', true)
                    })
            }
        }
    }
</script>
